import { http } from "config/http";
import { http49 } from "config/http49";
import { http91 } from "config/http91";

export const get_url_by_clientname = async (body: any) => {
    try {
        // const res: any = await http49.get(`get_url_by_client_name?client_env=${myConst.env}&website_id=${body}`)
        // need to test
        const res: any = await http49.get(`get_url_by_client_name?client_env=${localStorage.getItem("clientName")}&website_id=${body}`)
        return { result1: res?.data }
    } catch (error: any) {
        return { error1: error.message }
    }
}

export const get_zip = async (body: any) => {
    try {
        // need to test
        const res: any = await http49.get(`Genrate_vector?client_env=${localStorage.getItem("clientName")}&client_name=${body}`)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const get_scrape = async (body: any) => {
    try {
        // need to test
        const res: any = await http49.post(`scrape?client_env=${localStorage.getItem("clientName")}&base_urls=${body}`)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const get_scrape_histroy = async () => {
    try {
        // need to test
        const res: any = await http49.get(`scrape_history?client_env=${localStorage.getItem("clientName")}`)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const delete_history_by_id = async (body: any) => {
    try {
        // need to test
        const res: any = await http49.delete(`delete_row?client_env=${localStorage.getItem("clientName")}&website_id=${body}`)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const genrate_vectorDB = async (body: any) => {
    const destinationObject = { ...body, client_env: localStorage.getItem("clientName") };
    try {
        // need to test
        const res: any = await http91.post(`file_extraction`, destinationObject)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const getFilesByWebsiteId = async (body: any) => {
    try {
        const res: any = await http.get(`get_scrapper_file_data_by_website_id?client_env=${localStorage.getItem("clientName")}&website_id=${body}`)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const getStatusByWebsiteId = async (body: any) => {
    try {
        const res: any = await http.get(`get_status_by_websiteid?client_env=${localStorage.getItem("clientName")}&website_id=${body}`)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

